import * as React from 'react';
import { Checkbox, message, Tooltip, Button } from 'antd';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import StatementApiController from 'src/api/StatementApiController';
import StudentStatementDTO from 'src/models/statement/StudentStatementDTO';
import ViewStatementModal from 'src/components/admin/ViewStatementModal';

interface RouteParams {
    userId: string;
}

interface USStudentStatementsProps extends PageProps<RouteParams>, LocalizeContextProps {
}

interface USStudentStatementsState {
    loading: boolean;
    tableRecords: StudentStatementDTO[];
    currentStudentId: number;
    selectedStatement: StudentStatementDTO;
}

class USStudentStatements extends React.Component<USStudentStatementsProps, USStudentStatementsState> {
    private dataTableRef: DataTable<StudentStatementDTO>;

    constructor(props: USStudentStatementsProps) {
        super(props);
        bindAllOfThis(this, USStudentStatements.prototype);

        let userId = parseInt(this.props.match.params.userId, 10);

        this.state = {
            tableRecords: [],
            loading: true,
            currentStudentId: userId,
            selectedStatement: null,
        };
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<StudentStatementDTO>) => void): void {
        this.setState({ loading: true });

        StatementApiController.getStudentStatementTableData(requestState, this.state.currentStudentId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results.length > 0 ? results.data.results : [];
                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                console.log(tableRecords);
                callback(results.data);
            });
    }

    private openNotesModal(record: StudentStatementDTO) {
        this.setState({ selectedStatement: record });
    }

    private closeNotesModal() {
        this.setState({ selectedStatement: null });
    }

    private customTableColumns(): DataTableColumnProps<StudentStatementDTO>[] {
        return [
            {
                columnProps: {
                    title: this.props.translate('admin.studentStatements.columnHeader2'),
                    dataIndex: 'isCompleted',
                    width: 120,
                    sorter: true,
                    render: (text, record) => (
                        <Checkbox
                            checked={record.userCompletion != null ? record.userCompletion.isCompleted : false}
                            disabled />
                    ),
                },
                filterType: Filterer.BooleanCheckbox
            },
            DataTable.AdvancedColumns.Text(<Translate id="admin.studentStatements.columnHeader1" />, "statementText"),
            DataTable.AdvancedColumns.CustomLegacy("Notes", "userCompletion", 100, "DEFAULT", "Text", (text, record) => {
                if (record.userCompletion == null || record.userCompletion.statementNotes == null || record.userCompletion.statementNotes.length < 1) {
                    return null;
                }
                return "Yes";
            }),
            DataTable.AdvancedColumns.CustomLegacy("Files", "userCompletion", 100, "DEFAULT", "Text", (text, record) => {
                if (record.userCompletion == null || record.userCompletion.statementFiles == null || record.userCompletion.statementFiles.length === 0) {
                    return null;
                }
                return "Yes";
            }),
            {
                columnProps: {
                    key: 'view',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={"View Files"} arrowPointAtCenter>
                                <Button shape="circle" icon="profile" onClick={() => this.openNotesModal(record)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];
    }

    private handleRedirect(): void {
        this.props.history.push(Routes.getRoute(Routes.ADMIN_UNIVERSAL_USER_SEARCH), this.props.location.state);
    }

    render() {
        return (
            <div>
                <h2>{this.props.translate('admin.studentStatements.tableHeader')}</h2>

                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'statementUserId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('common.back', this.handleRedirect),
                        new DataTableButtonReset()
                    ]} />

                <ViewStatementModal
                    visible={this.state.selectedStatement != null}
                    statement={this.state.selectedStatement}
                    onClose={this.closeNotesModal}
                />
            </div>
        );
    }
}

export default withLocalize(USStudentStatements as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/universalSearch/USStudentStatements.tsx